/**
 * @generated SignedSource<<6236d56145c782615f95d6959701cb81>>
 * @relayHash 04fbf168a3262118564152ceaac9cf66
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ccbfdc2000afcf6f467604bb74274135ff5abce33df5678e3a06479f30fdf193

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessFormBuilderAppMemoQuery } from './JiraBusinessFormBuilderAppMemoQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessFormBuilderAppMemoQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "ccbfdc2000afcf6f467604bb74274135ff5abce33df5678e3a06479f30fdf193",
    "metadata": {},
    "name": "JiraBusinessFormBuilderAppMemoQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
